module.exports = "pegasus_template/assets/themelp1/small/home-bg.png";